<template>
    <div class="main_box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>基本信息管理</el-breadcrumb-item>
            <el-breadcrumb-item>重置密码</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form class="form" :model="form" size="small" label-width="100px" ref="form">
            <el-form-item label="用户账号" prop="account" class="input_400">
                <el-input v-model="form.account"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password" class="input_400">
                <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="重复密码" prop="rePassword" class="input_400">
                <el-input v-model="form.rePassword" type="password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="resetPassword" :loading="saving">确认</el-button>
                <el-button @click="$refs.form.resetFields()">清空</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                account: '',
                password: '',
                rePassword: '',
            },
            saving: false
        }
    },
    methods: {
        resetPassword() {
            console.log(this.form);
            this.saving = true
            this.ajax.post('/system/reset-pwd', this.form).then(data => {
                this.$message({
                    type: 'success',
                    message: '操作成功！'
                })
                this.saving = false
            }).catch(() => {
                this.saving = false
            })
        },


    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/basic/resetPassword.vue